var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-top"},[_c('RouterLink',{staticClass:"logo-link",attrs:{"to":_vm.logoRoute}},[_c('Logo')],1),_c('div',{staticClass:"nav-and-user"},[_c('NavBar'),(_vm.loggedIn)?_c('HeaderUser'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }